import { faker } from '@faker-js/faker';

import type { AlertSettings } from '~/api/types';
import {
  HIGH_LACTATE_ALERT_DURATION_ITEMS,
  HIGH_LACTATE_ALERT_ITEMS,
} from '~/components/forms/patientSettings/constants';

export const alertSettingsFactory = ({
  overrides,
}: {
  overrides?: Partial<AlertSettings>;
}): AlertSettings => {
  return {
    alertPhone: faker.phone.number({ style: 'international' }),
    // Use allowed lactate threshold values (e.g., 1.5, 2.0, ..., 6.0 mmol/L)
    highLactateAlertAbove: faker.helpers.arrayElement(HIGH_LACTATE_ALERT_ITEMS)
      .value,
    // Use allowed durations in minutes (e.g., 30, 60, 90, 120)
    highLactateAlertDuration: faker.helpers.arrayElement(
      HIGH_LACTATE_ALERT_DURATION_ITEMS,
    ).value,
    displayLactateData: true,
    highLactateAlert: true,
    ...overrides,
  } satisfies AlertSettings;
};
